import dayjs from "dayjs";

import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall } from "@components/Typography";
import { DateFormat, TransactionType } from "@ctypes";
import { useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { TransferItem } from "@routes/TransfersRoute/TransferItem";
import { ACHReturnModal } from "./ACHReturnModal";
import { useStyles } from "./styles";
import { TransactionListProps } from "./types";
import { UpdateTransferModal } from "./UpdateTransferModal";
import { ModalType } from "./UpdateTransferModal/types";

export const TransactionList = ({ data, upcoming = false }: TransactionListProps) => {
  const { show } = useModal();

  const styles = useStyles();

  const groupedTransactions = data.reduce(
    (acc, item) => {
      const formattedDate = item?.date
        ? dayjs(item.date).format(DateFormat.FullDate).toUpperCase()
        : i18n.t(Translations.TransfersRouteUnknownDate);

      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }

      acc[formattedDate].push(item);
      return acc;
    },
    {} as Record<string, any[]>,
  );

  return (
    <div>
      {Object.entries(groupedTransactions).map(([date, transactions]) => (
        <div key={date}>
          <BodySmall style={styles.date}>{date}</BodySmall>
          <Spacing size={SpacingSizes.S} />
          {transactions.map((item, index) => {
            const isContribution = [
              TransactionType.Contribution,
              TransactionType.OneTimeContribution,
              TransactionType.RecurringContribution,
            ].includes(item?.type as TransactionType);

            const isWithdrawal = [
              TransactionType.Withdrawal,
              TransactionType.WithdrawalAll,
            ].includes(item?.type as TransactionType);

            const isACHReturn = item?.type === TransactionType.Reversal;

            const isSelectable = isContribution || isWithdrawal || isACHReturn;

            return (
              <div key={`${item?.id}-${index}`}>
                <TransferItem
                  title={item?.description}
                  amountInCents={item?.amountInCents}
                  transactionType={item?.type}
                  status={item?.status}
                  upcoming={upcoming}
                  beneficiaryName={item?.beneficiaryName}
                  goalName={item?.goalName}
                  subscriptionPeriod={item?.subscriptionPeriod}
                  style={{ cursor: isSelectable ? "pointer" : "default" }}
                  onClick={() => {
                    if (item) {
                      if (isContribution) {
                        show(<UpdateTransferModal item={item} type={ModalType.Contribution} />);
                      } else if (isWithdrawal) {
                        show(<UpdateTransferModal item={item} type={ModalType.Withdrawal} />);
                      } else if (isACHReturn) {
                        show(<ACHReturnModal item={item} />);
                      }
                    }
                  }}
                />
                {index < transactions.length - 1 && <Spacing size={SpacingSizes.M} />}
              </div>
            );
          })}
          <Spacing size={SpacingSizes.M} />
        </div>
      ))}
    </div>
  );
};
